var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.label,"value":_vm.value,"items":_vm.options,"no-data-text":"无权益分组"},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }